var _a, _b;
import { CreditCardFields } from './types';
export var defaultLabels = (_a = {},
    _a[CreditCardFields.CARD_NUMBER] = 'Card number',
    _a[CreditCardFields.MONTH] = 'Expiration date',
    _a[CreditCardFields.YEAR] = 'Expiration date',
    _a[CreditCardFields.CVV] = 'CVV',
    _a[CreditCardFields.FIRST_NAME] = 'First name on card',
    _a[CreditCardFields.LAST_NAME] = 'Last name on card',
    _a);
export var defaultIdentifiers = (_b = {},
    _b[CreditCardFields.CARD_NUMBER] = 'card-number',
    _b[CreditCardFields.MONTH] = 'card-month',
    _b[CreditCardFields.YEAR] = 'card-year',
    _b[CreditCardFields.CVV] = 'card-cvv',
    _b[CreditCardFields.FIRST_NAME] = 'first-name',
    _b[CreditCardFields.LAST_NAME] = 'last-name',
    _b);
